// extracted by mini-css-extract-plugin
export default {"videoModalContainer":"videoDialog_videoModalContainer__90vGJ","hiddenVideo":"videoDialog_hiddenVideo__fmdNf","notHiddenVideo":"videoDialog_notHiddenVideo__eM5kN"};